/* eslint-disable security/detect-object-injection */
const moment = require('moment');

function mapCategoryToCardImage(categoryType) {
  if (categoryType === 'addition') return 'images/changelog/cardsBackground/addition.png';
  if (categoryType === 'removal') return 'images/changelog/cardsBackground/removal.png';
  if (categoryType === 'update') return 'images/changelog/cardsBackground/update.png';
  return 'images/changelog/cardsBackground/fix.png';
}

function getByPathId(news, pathId) {
  return news.filter((e) => e.path_id === pathId)[0] || null;
}

function sliceNew(news, limit) {
  return limit ? news.slice(0, limit) : news;
}

function filterByType(news, [types], limit = null) {
  return sliceNew(news.filter((e) => types.includes(e.type)), limit);
}

function filterByHighLight(news, limit = null) {
  return sliceNew(news.filter((e) => e.highlight === true), limit);
}

function filterByTags(news, tag, lang, limit = null) {
  return sliceNew(news.filter((e) => e.tags[lang].includes(tag)), limit);
}

function filterByCategoryType(news, type, limit = null) {
  return sliceNew(news.filter((e) => e.category_type === type), limit);
}

function filterBySite(news, siteId, limit = null) {
  return sliceNew(news.filter((e) => e.sites.includes(siteId)), limit);
}

function orderByDate(news, limit = null) {
  const dateOrderedNews = news.sort((obj1, obj2) => {
    let compare = 0;
    const comparable1 = moment(obj1?.date_published).format('YYYY/MM/DD hh:mm:ss');
    const comparable2 = moment(obj2?.date_published).format('YYYY/MM/DD hh:mm:ss');
    if (comparable1 > comparable2) compare = -1;
    if (comparable1 < comparable2) compare = 1;
    return compare;
  });
  return limit ? dateOrderedNews.slice(0, limit) : dateOrderedNews;
}

function orderByHighLight(news, limit = null) {
  const newsPosts = filterByType(news, ['news']);
  const dateOrderedNews = orderByDate(newsPosts);
  const highLightOrderedNews = dateOrderedNews.sort((obj1, obj2) => {
    let compare = 0;
    if (obj1.highlight && !obj2.highlight) compare = -1;
    if (!obj1.highlight && obj2.highlight) compare = 1;
    return compare;
  });
  return limit ? highLightOrderedNews.slice(0, limit) : highLightOrderedNews;
}

function isVoiced({ sites, title, summary, lang, siteId }) {
  try {
    const showVoiced = !!((sites.includes('mla') && siteId === 'MLA'));
    const thereIsVoiced = (title?.voiced && (summary?.voiced));
    return (showVoiced && lang === 'es' && thereIsVoiced);
  } catch (error) {
    console.trace(error);
    return false;
  }
}

module.exports = {
  mapCategoryToCardImage,
  getByPathId,
  filterByType,
  filterByHighLight,
  filterByTags,
  filterByCategoryType,
  filterBySite,
  orderByDate,
  orderByHighLight,
  isVoiced,
};
